import React, { Suspense } from "react";
import { createContext } from "react";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SectionSliderProductCard from "components/SectionSliderProductCard";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import Heading from "components/Heading/Heading";
import { PRODUCTS, SPORT_PRODUCTS } from "data/data";
import SearchTabs from "components/SectionHero/SearchTabs";
import SellBuyMob from "components/SectionHero/SellBuyMob";
import CaroHero from "../../components/SectionHero/libCaro/CaroHero";
import useIntersectionObserver from "hooks/useIntersectionObserver";
import { CircularProgress } from "@mui/material";
import "./home_page.css";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ViewAllBtn from "./components/moli/ViewAllBtn";

const CustomBlog = React.lazy(() => import("components/CustomBlog/CustomBlog"));
const PopuBrands = React.lazy(() => import("./brands/PopuBrands"));
const SectionSliderProductCardLatest = React.lazy(
  () => import("components/SectionSliderProductLatest")
);
const BackgroundSection = React.lazy(
  () => import("components/BackgroundSection/BackgroundSection")
);
const SectionGridMoreExplore = React.lazy(
  () => import("components/SectionGridMoreExplore/SectionGridMoreExplore")
);
const CustomVideos = React.lazy(
  () => import("components/CustomVideos/CustomVideos")
);

export const GlobalInfo = createContext<any>("");

function PageHome() {
  const { isVisible, observerRef }: any = useIntersectionObserver();

  return (
    <div>
      <div className="nc-PageHome relative overflow-hidden">
        <Helmet>
          <title>AgrotracDigital:New Machinery,Rentals,Parts</title>
        </Helmet>

        <div className="my-3 md:my-0 banner_min_height">
          <CaroHero />
        </div>

        <div className="md:hidden">
          <SellBuyMob />
        </div>

        <div className="md:hidden my-5">
          <SearchTabs />
        </div>

        <div className="relative lg:space-y-8 mt-4">
          {/* SECTION */}
          <div className="container">
            <SectionSliderProductCard
              data={[
                PRODUCTS[4],
                SPORT_PRODUCTS[5],
                PRODUCTS[7],
                SPORT_PRODUCTS[2],
                PRODUCTS[6],
              ]}
            />
            <div className="flex justify-end">
              <ViewAllBtn text={"View All"} link={"/new-implements"} />
            </div>
          </div>

          <div className="container flex items-center justify-center my-4 md:my-1">
            <img src="images/business-strategy-leaderboard-ad.jpg" alt="" />
          </div>

          <div className="how_it_works_bg p-4 my-8 md:my-1">
            <h2 className="mt-3 mb-8 text-center text-sm md:text-lg font-medium text-[#1550A1]">
              Complete Solutions for Agri Machinery
            </h2>
            <div className="container">
              <SectionHowItWork />
            </div>
          </div>

          <div className="mt-6 container">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="md:col-span-3">
                <Suspense fallback={<CircularProgress />}>
                  <SectionSliderProductCardLatest
                    heading="Latest Machinery"
                    subHeading="from 2022"
                    url="/showroom/api/v1/product_list/"
                  />
                </Suspense>
              </div>

              <div className="advertisement pt-2 md:pt-10">
                <Link
                  to={"/new-implements/2/FARMPOWER%20ROTAVATOR%20XXTRA%20DUM/"}
                >
                  <img
                    src="images/441927465_972805741300417_7932176696816619435_n.jpg"
                    alt=""
                    className="rounded-md"
                  />
                </Link>
              </div>
            </div>
            <div className="flex justify-end">
              <ViewAllBtn text={"View All"} link={"/new-implements"} />
            </div>
          </div>

          <div
            className="how_it_works_bg container-fluid my-4 md:my-0"
            ref={observerRef}
          >
            <div className="container h-full w-full md:my-6">
              <div className={`nc-SectionSliderProductCard mb-3`}>
                <Heading className={` mb-3`}>{`Popular Brands`}</Heading>
                <div className="popularBrandLogos">
                  <Suspense fallback={<CircularProgress />}>
                    <div className="relative py-1 lg:py-1.5">
                      <PopuBrands isVisible={isVisible} />
                    </div>
                  </Suspense>
                </div>
              </div>
              <div className="flex justify-end">
                <ViewAllBtn text={"View All"} link={"/brand/kubota"} />
              </div>
            </div>
          </div>

          <Suspense fallback={<CircularProgress />}>
            {/* SECTION Category and Sub_Cat */}
            <div className="relative py-1 lg:py-1.5">
              <BackgroundSection />
              <SectionGridMoreExplore />
              <div className="container flex justify-end">
                <ViewAllBtn text={"View All"} link={"/new-implements"} />
              </div>
            </div>
          </Suspense>

          <div className="container relative" id="agro_blog_sec">
            <Heading rightDescText="" className="mt-6 pb-4">
              Latest Blogs
            </Heading>

            <Suspense fallback={<CircularProgress />}>
              <CustomBlog />
            </Suspense>

            <div className="flex justify-end">
              <ViewAllBtn text={"View All"} link={"/posts"} />
            </div>
          </div>

          <div className="container relative">
            <Heading rightDescText="" className="mt-6 py-4">
              Latest Videos
            </Heading>

            <Suspense fallback={<CircularProgress />}>
              <CustomVideos />
            </Suspense>

            <div className="flex justify-end">
              <ViewAllBtn text={"View All"} link={"/videos"} />
            </div>
          </div>

          {/*  */}
          <div className="how_it_works_bg py-2 md:py-8">
            <h2 className="text-lg font-medium text-[#1550A1] text-center font-roboto">
              Testimonials
            </h2>
            <SectionClientSay />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHome;
